import { DateTime } from 'common/utils/date';

export const getLocalDayAndTime = (sendEmailAt?: string) => {
  const dateObj = sendEmailAt ? DateTime.fromISO(sendEmailAt) : DateTime.now();
  const dayOfWeek = dateObj.weekday === 7 ? 0 : dateObj.weekday;

  return {
    dayOfWeek,
    sendAtTime: dateObj.toFormat('T'),
  };
};

export const formatDayAndTime = ({ dayOfWeek, sendAtTime }) => {
  const dayOfWeekUpdated = dayOfWeek === '0' ? '7' : dayOfWeek;
  return DateTime.fromFormat(`${dayOfWeekUpdated}:${sendAtTime}`, 'c:T')
    .toUTC()
    .toISO();
};

export const formatReadableDayAndTime = sendEmailAt => {
  return DateTime.fromISO(sendEmailAt).toFormat("cccc 'at' t");
};
